import { useAppUpdateAvailable } from '@backoffice-frontend/common'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

export const AppUpdateToast = () => {
  const appUpdateAvailable = useAppUpdateAvailable()
  const { pathname } = useLocation()
  const previousPathnameRef = useRef(pathname)

  useEffect(() => {
    if (!appUpdateAvailable) return

    const previousPathname = previousPathnameRef.current
    previousPathnameRef.current = pathname

    if (pathname === previousPathname) return

    window.location.reload()
  }, [appUpdateAvailable, pathname])

  return null
}
